import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AssinaturaService } from './assinatura.service';
import { URL_LOGOUT } from '../constante';

@Component({
  selector: 'app-assinaturas-assinador',
  templateUrl: './assinaturas-assinador.component.html',
  styleUrls: ['./assinaturas-assinador.component.css'],
  providers: [AssinaturaService]
})
export class AssinaturasAssinadorComponent implements OnInit {
  public titulo: string = 'Documentos a Assinar';
  public pendentes: any[] = [];
  public assinadas: any[] = [];
  public aba: string = 'pendentes';
  public busy: Promise<any>;
  public modalAberto: boolean = false;
  public preview: any = null;
  public previewHtml: SafeHtml = null;
  public previewErro: string = null;
  public itemSelecionado: any = null;

  constructor(
    private assinaturaService: AssinaturaService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.carregar();
  }

  carregar(): void {
    this.busy = this.assinaturaService.getMinhasAssinaturas()
      .then((dados) => {
        this.pendentes = dados.pendentes || [];
        this.assinadas = dados.assinadas || [];
      });
  }

  mudarAba(aba: string): void {
    this.aba = aba;
  }

  abrirPreview(item: any): void {
    this.itemSelecionado = item;
    this.preview = null;
    this.previewHtml = null;
    this.previewErro = null;
    this.modalAberto = true;

    this.busy = this.assinaturaService.getPreview(item.id)
      .then((dados) => {
        this.preview = dados;
        this.previewHtml = this.sanitizer.bypassSecurityTrustHtml(dados.html);
      })
      .catch(() => {
        this.previewErro = 'Não foi possível carregar a pré-visualização.';
      });
  }

  fecharModal(): void {
    this.modalAberto = false;
    this.preview = null;
    this.previewHtml = null;
    this.previewErro = null;
    this.itemSelecionado = null;
  }

  confirmarAssinatura(): void {
    if (!this.itemSelecionado) {
      return;
    }

    this.busy = this.assinaturaService.assinar(this.itemSelecionado.id)
      .then(() => {
        this.fecharModal();
        this.carregar();
      });
  }

  assinarComGovBr(): void {
    if (!this.itemSelecionado) {
      return;
    }

    sessionStorage.setItem('govbr_assinatura_id', String(this.itemSelecionado.id));

    this.busy = this.assinaturaService.iniciarGovBr(this.itemSelecionado.id)
      .then((resp) => {
        if (resp && resp.dados && resp.dados.url) {
          window.location.href = resp.dados.url;
        } else if (resp && resp.url) {
          window.location.href = resp.url;
        }
      });
  }

  posicaoLabel(posicao: any): string {
    switch (String(posicao)) {
      case '1': return 'ESQ';
      case '2': return 'CEN';
      case '3': return 'DIR';
      default: return posicao;
    }
  }

  downloadP7s(item: any): void {
    if (item && item.id) {
      window.open(this.assinaturaService.downloadP7sUrl(item.id), '_blank');
    }
  }

  getUrlValidacao(item: any): string {
    return URL_LOGOUT + '/validar-assinatura/' + item.id;
  }
}



// WEBPACK FOOTER //
// ./src/app/assinaturas/assinaturas-assinador.component.ts